/** Benelli M4, as a thing you can carry. The gun itself is `sim/weapons/guns/benelliM4.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const BENELLI_M4_ITEM = {
  id: 'benelliM4',
  kind: 'weapon',
  label: 'Benelli M4',
  description:
    'A 12 gauge that cycles itself. The room is cleared before anybody has to pump anything.',
  rarity: 'rare',
  weightKg: 3.8,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'benelliM4',
} as const satisfies WeaponItem;
